const CONNECTION_TIMEOUT = 60000;

const COPY_BTN_TIMEOUT = 3000;

const NUVIU_APP_STORE_LINK = 'https://apps.apple.com/ca/app/nuviu/id1616197482';

const WEB_BLUETOOTH_SAMPLES_LINK =
  'https://googlechrome.github.io/samples/web-bluetooth/index.html';

const NUVIU_USER_AGENT = 'Nuviu';

export {
  CONNECTION_TIMEOUT,
  COPY_BTN_TIMEOUT,
  NUVIU_APP_STORE_LINK,
  WEB_BLUETOOTH_SAMPLES_LINK,
  NUVIU_USER_AGENT,
};
